<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>EDIT - USER MANAGEMENT</h2>
       <p>Edit User record</p>
       <!--<a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
       </div>
      </div>
       <form [formGroup]="editregisterForm">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
            <div class="form-group">
            <label for="Note">User Role</label>
            <select id="userrole" name="userrole" class="selectpicker form-control myFakeClass" (change)="farmuser($event)">
            <option selected="selected">Director</option>
            <option>Admin</option>
            <option>University Officer</option>
            <option>Guest user</option>
            <option>Farm user</option>
            <option>Student/Research scholars</option>
            </select>
            </div>
            </div>
          <div class="col-lg-4 col-md-6 col-sm-6">
      <div class="form-group">
        <label for="Species Name">User Name</label>
        <input type="text" id="username" name="username"  formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" autofocus>
        <div class="selectvalidate"  *ngIf="f.username.hasError('required') && f.username.touched">User Name must be filled out
        </div> 
      </div>
     </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
      <div class="form-group">
      <label for="Note">User ID</label>
      <input type="text" id="userid" name="userid" value=""  formControlName="userid" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.userid.errors }" (keyup)="uniquecheckvalidationid($event)">
      <div class="selectvalidate"  *ngIf="f.userid.hasError('required') && f.userid.touched">User ID must be filled out
      </div> 
      </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop" *ngIf="farmuservalue==('Farm user'); else elseBlock">
          <div class="form-group">
          <label for="Species Name">Farm Name</label>
          <select  name="farmname" id="farmname" class="form-control selectpicker myFakeClass1" (change)="selectfarmuser($event)" data-size="5">
            <option selected disabled>Select Farm Name</option>
          <option *ngFor='let farmlist of getfarmsListData' [value]="farmlist.tnfr_id">{{farmlist.tnfr_name}}</option>
        </select>
          </div>
      </div>
      <ng-template #elseBlock>
        <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Note">Department</label>
          <input type="text"  id="userdepartment" name="userdepartment" value=""  class="form-control" >
        </div>
      </div></ng-template>
      
    <!--<div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
        <label for="Note">User ID</label>
        <select  id="userid" name="userid" class="selectpicker form-control">
        <option selected="selected">F135893</option>
        <option >F1356491</option>
        <option >F13856491</option>
        </select>
        </div>
        </div>--> 
     <div class="col-lg-4 col-md-6 col-sm-6">
     <div class="form-group">
     <label for="Note">User Email</label>
     <input type="email"  id="useremail" name="useremail" value="" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" (keyup)="uniquecheckvalidation($event)">
     <div class="selectvalidate" *ngIf="f.email.hasError('required') && f.email.touched">Contact Email must be filled out</div>
      <div class="selectvalidate" *ngIf="f.email.hasError('email') && f.email.touched">Email must be a valid email address</div>
     
     </div>
     </div>
     <div class="col-lg-4 col-md-6 col-sm-6">
     <div class="form-group">
     <label for="Note">User Contact No</label>
     <input type="text" class="form-control"  id="usercontact" name="usercontact" value="" formControlName="mobileNumber" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.mobileNumber.errors }">
     
      <div class="selectvalidate" *ngIf="f.mobileNumber.hasError('required') && f.mobileNumber.touched">Contact Number must be filled out</div>
      <div class="selectvalidate" *ngIf="f.mobileNumber.hasError('pattern') && f.mobileNumber.touched">Please, Enter 10-12 digit Mobile Number.</div>

    </div>
     </div>
     
    <div class="col-lg-4 col-md-6 col-sm-6  dropdowntop">
      <div class="form-group">
      <label for="Note">Status</label>
        <select id="status" name="status" class="selectpicker form-control myFakeClass2">
        <option value="1">Active</option>
        <option value="0">In Active</option>
        </select>
        </div>
      </div>
    <!--<div class="col-lg-4 col-md-6 col-sm-6">
     <div class="form-group">
     <label for="Note">Password</label>
     <input id="pswd" name="pswd" type="password" class="form-control"  formControlName="password"  [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div class="selectvalidate" *ngIf="f.password.errors.required">Password is required</div>
                            <div class="selectvalidate" *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                        </div>
    </div>
     </div>
     <div class="col-lg-4 col-md-6 col-sm-6">
      <div class="form-group">
      <label for="Note">Confirm Password</label>
      <input  id="cnfirmpswd" name="cnfirmpswd" type="password"  class="form-control" formControlName="confirmPassword"  [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }">
       <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                            <div class="selectvalidate" *ngIf="f.confirmPassword.errors.required">Confirm Password is required</div>
                            <div class="selectvalidate" *ngIf="f.confirmPassword.errors.mustMatch">Passwords must match</div>
                        </div>
      </div>
      </div>-->
     </div>
            <div class="col-lg-12 col-md-12 col-sm-12 text-center">
            <a (click)="onSubmit()"class="btn btn-fill btn-primary mb-3">Submit 
            <div class="ripple-container"></div></a>
            <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
            </div>     
       </form>
     </div>
   </div>
 </div>
